(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', init);

  function init() {
    var article = document.querySelector('.blog-content-desc.rte');
    if (!article) return;

    createProgressBar();
    addReadTime(article);
    wrapSections(article);
    addSectionNumbers();
    addCopyButtons(article);
    addMessageCount(article);
    createBackToTop();
    initScrollAnimations();
  }

  /* ── Progress Bar ── */

  function createProgressBar() {
    var bar = document.createElement('div');
    bar.className = 'blog-progress-bar';
    bar.innerHTML = '<div class="blog-progress-fill"></div>';
    document.body.appendChild(bar);

    var fill = bar.querySelector('.blog-progress-fill');
    var ticking = false;

    window.addEventListener('scroll', function () {
      if (!ticking) {
        requestAnimationFrame(function () {
          var scrollTop = window.scrollY;
          var docHeight = document.documentElement.scrollHeight - window.innerHeight;
          var progress = docHeight > 0 ? (scrollTop / docHeight) * 100 : 0;
          fill.style.width = progress + '%';
          ticking = false;
        });
        ticking = true;
      }
    });
  }

  /* ── Read Time ── */

  function addReadTime(article) {
    var text = article.textContent || '';
    var words = text.trim().split(/\s+/).length;
    var minutes = Math.max(1, Math.round(words / 200));

    var meta = document.querySelector('.blog-meta');
    if (!meta) return;

    var badge = document.createElement('span');
    badge.className = 'blog-read-time';
    badge.textContent = minutes + ' min read';
    meta.appendChild(badge);
  }

  /* ── Message Count Badge ── */

  function addMessageCount(article) {
    var blockquotes = article.querySelectorAll('.message-card');
    if (blockquotes.length < 2) return;

    var banner = document.querySelector('.blog-detail-banner-content > div[class*="container"]');
    if (!banner) return;

    var badge = document.createElement('div');
    badge.className = 'blog-message-count';
    badge.innerHTML = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><rect x="9" y="9" width="13" height="13" rx="2" ry="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg> ' + blockquotes.length + ' ready-to-use message templates';
    banner.appendChild(badge);
  }

  /* ── Back to Top ── */

  function createBackToTop() {
    var btn = document.createElement('button');
    btn.className = 'back-to-top';
    btn.setAttribute('aria-label', 'Back to top');
    btn.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="18 15 12 9 6 15"/></svg>';
    document.body.appendChild(btn);

    btn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });

    var ticking = false;
    window.addEventListener('scroll', function () {
      if (!ticking) {
        requestAnimationFrame(function () {
          if (window.scrollY > 600) {
            btn.classList.add('visible');
          } else {
            btn.classList.remove('visible');
          }
          ticking = false;
        });
        ticking = true;
      }
    });
  }

  /* ── Section Cards ── */

  function wrapSections(article) {
    var children = Array.from(article.childNodes);
    var sections = [];
    var current = [];

    children.forEach(function (node) {
      if (node.nodeType === 1 && node.nodeName === 'HR') {
        if (current.length > 0) {
          sections.push(current);
          current = [];
        }
      } else {
        if (node.nodeType === 3 && !node.textContent.trim()) return;
        if (node.nodeType === 1 && node.nodeName === 'P' && !node.textContent.trim() && !node.querySelector('img')) return;
        current.push(node);
      }
    });

    if (current.length > 0) {
      sections.push(current);
    }

    article.innerHTML = '';

    sections.forEach(function (sectionNodes, index) {
      var card = document.createElement('div');
      card.className = 'article-card';
      card.setAttribute('data-section', index);

      sectionNodes.forEach(function (node) {
        card.appendChild(node);
      });

      article.appendChild(card);
    });
  }

  /* ── Section Numbers ── */

  function addSectionNumbers() {
    var headings = document.querySelectorAll('.article-card h1, .article-card h2, .article-card h3, .article-card h4, .article-card h5, .article-card h6');
    var num = 0;

    headings.forEach(function (heading) {
      num++;
      var badge = document.createElement('span');
      badge.className = 'section-number';
      badge.textContent = String(num).padStart(2, '0');
      heading.classList.add('has-section-number');
      heading.id = 'section-' + num;
      heading.insertBefore(badge, heading.firstChild);
    });
  }

  /* ── Copy Buttons ── */

  function addCopyButtons(article) {
    var blockquotes = article.querySelectorAll('blockquote');

    blockquotes.forEach(function (bq) {
      var wrapper = document.createElement('div');
      wrapper.className = 'message-card';

      var label = document.createElement('span');
      label.className = 'message-card-label';
      label.textContent = 'Message Template';

      var btn = document.createElement('button');
      btn.className = 'copy-btn';
      btn.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="9" y="9" width="13" height="13" rx="2" ry="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg> Copy';

      btn.addEventListener('click', function () {
        var text = bq.innerText.trim().replace(/^[""\u201C\u201D"]+|[""\u201C\u201D"]+$/g, '').trim();
        navigator.clipboard.writeText(text).then(function () {
          btn.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg> Copied!';
          btn.classList.add('copied');
          setTimeout(function () {
            btn.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="9" y="9" width="13" height="13" rx="2" ry="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg> Copy';
            btn.classList.remove('copied');
          }, 2000);
        });
      });

      bq.parentNode.insertBefore(wrapper, bq);
      wrapper.appendChild(label);
      wrapper.appendChild(bq);
      wrapper.appendChild(btn);
    });
  }

  /* ── Scroll Animations ── */

  function initScrollAnimations() {
    var cards = document.querySelectorAll('.article-card, .message-card');

    if (cards.length > 0) {
      cards[0].classList.add('visible');
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });

    cards.forEach(function (card, index) {
      if (index > 0) observer.observe(card);
    });
  }
})();
